import { Moment } from 'moment';
import { CourseCode } from '@sdir/httpclient/lib/clients/aps/course';
import { Organization, Vessel } from '@sdir/httpclient/lib/clients/core/search';
import {
  AttachmentResult,
  AttachmentType,
  ServiceReportQualificationResult,
} from '@sdir/httpclient/lib/clients/aps/application';
import { ServiceReportExtended } from '@sdir/httpclient/lib/clients/aps/seagoing';
import { Person as AssessmentPerson } from '@sdir/httpclient/lib/clients/aps/assessor';
import { Competence } from '@sdir/httpclient/lib/clients/aps/additionalcompetence';
import { ContactInfoDto } from './ContactInfoDto';

export type AttachmentUpdate = {
  attachmentUid: string;
  newFile: File | null;
  newType?: AttachmentType;
};
export type NewAttachment = {
  file: File;
  type: AttachmentType;
};

export type AddedQualifications = {
  seagoing: ServiceReportExtended[];
  newSeagoing: ServiceReportQualificationResult;
};

export interface AppState {
  contactInfo: ContactInfoDto;
}

export interface NewVesselInput {
  name: string;
  imoNumber: string;
  callSign: string;
  country: string;
  registry: string;
}

export interface VesselSubformInput {
  useExisting: boolean;
  existingVessel: Vessel | null;
  newVessel: NewVesselInput;
}

export interface SeagoingSubformInput {
  startDate: Moment | null;
  endDate: Moment | null;
  occupation: string | null;
  hours: number | null;
}

export interface AddedCourse {
  date: Moment | null;
  course: CourseCode | null;
  organization: Organization | null;
  foreignCourse: boolean;
}

export interface AddedAssessment {
  assessor: AssessmentPerson | null;
  vessel: VesselSubformInput;
  assessmentCode: string | null;
  periodStart: Moment | null;
  periodEnd: Moment | null;
}

export interface AddedSeagoing {
  vessel: Vessel;
  details: AddedSeagoingDetails[];
}

export interface AddedSeagoingDetails {
  occupationCode: string;
  startDate: Moment;
  endDate: Moment;
  totalHours: number;
  existingReport: ServiceReportExtended | null;
}

export interface SystemState {
  appState: AppState;
}

export const isAttachmentResult = (
  fileOrReference: File | AttachmentResult
): fileOrReference is AttachmentResult =>
  !!fileOrReference &&
  !!(fileOrReference as AttachmentResult).blobName &&
  !!(fileOrReference as AttachmentResult).uid;

export interface NewOrganizationInput {
  name: string;
  type: string;
  organizationNumber: string;
  countryCode: string | null;
}

export interface OrganizationInput {
  existingOrganization: Organization | null;
  useExisting: boolean;
  newOrganization: NewOrganizationInput;
}

export interface AddedAdditionalCompetence {
  vessel: Vessel;
  competence: Competence;
  organization?: Organization;
  registratorName?: string;
  applicationReference?: string;
  applicationGroupUid?: string;
}
